export default {
  title: 'List of Users',
  inputPlaceholder: 'User name, email',
  mfaResetDetails: 'MFA Reset details',
};
